import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@xyflow/react/dist/style.css'

// Register service worker for PWA functionality (deferred to not block initial load)
if ('serviceWorker' in navigator) {
  // Defer service worker registration to after the app has loaded
  const registerSW = async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      // Handle service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker is available, refresh the page
              console.log('New service worker available, refreshing...');
              window.location.reload();
            }
          });
        }
      });
      console.log('Service worker registered successfully');
    } catch (registrationError) {
      console.log('SW registration failed: ', registrationError);
    }
  };

  // Register after initial render and a small delay
  setTimeout(registerSW, 100);
}

createRoot(document.getElementById("root")!).render(<App />);
